import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "最新行业动态、定档消息与幕后花絮",
    tone: "primary",
  },
  {
    to: "/category/plot",
    icon: "ri-lightbulb-line",
    title: "剧情解析",
    desc: "结局拆解、伏笔盘点与人物深度剖析",
    tone: "accent",
  },
  {
    to: "/category/works",
    icon: "ri-film-line",
    title: "作品库",
    desc: "按类型、年代、地区检索你感兴趣的作品",
    tone: "secondary",
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
          >
            <span
              className={`w-14 h-14 shrink-0 flex items-center justify-center rounded-lg ${
                entry.tone === "primary"
                  ? "bg-primary-100 text-primary-600"
                  : entry.tone === "accent"
                    ? "bg-accent-100 text-accent-700"
                    : "bg-secondary-100 text-secondary-700"
              }`}
            >
              <i className={`${entry.icon} text-2xl`} />
            </span>
            <span className="min-w-0">
              <span className="flex items-center gap-2">
                <span className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {entry.title}
                </span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:translate-x-1 group-hover:text-primary-500 transition-all" />
              </span>
              <span className="block text-sm text-foreground-500 mt-1 leading-relaxed">
                {entry.desc}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}